import { I18n } from "react-redux-i18n";
import * as moment from "moment-timezone";
import _ from "lodash";
import promisePool from "es6-promise-pool";
import { layoutedEvents } from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	beeTemplate,
	beeTemplate1Render,
} from "../../scenes/campaigns/scenes/campaignFlow/data/baseTemplates";
import { listContactsOfList } from "../../scenes/contacts/actions";
import { listSegmentService } from "assets/js/services/segmentService";
import { getContactsOfListService } from "assets/js/services/contactService";
import { mapBEStepsToFEEvents } from "../../scenes/automations/containers/editor/Mapper";
import {
	GET_ABTEST_STATS_SUCCESS,
	LIST_AUTOMATIONS_FAILURE,
	LIST_AUTOMATIONS_SUCCESS,
	SET_AUTOMATION,
	LIST_AUTOMATION_BLUEPRINTS_SUCCESS,
	UPDATE_AUTOMATION_EVENT,
	ADD_AUTOMATION_EVENT,
	RESET_AUTOMATION_EVENTS,
	CREATE_AUTOMATION_SUCCESS,
	CREATE_AUTOMATION_FAILURE,
	GET_AUTOMATION_SUCCESS,
	RENAME_AUTOMATION_SUCCESS,
	GET_AUTOMATION_FAILURE,
	LIST_AUTOMATION_BLUEPRINTS_FAILURE,
	DELETE_AUTOMATION_EVENT,
	GET_ACTION_SUCCESS,
	DEACTIVATE_AUTOMATION_SUCCESS,
	ACTIVATE_AUTOMATION_FAILURE,
	ACTIVATE_AUTOMATION_SUCCESS,
	UPDATE_AUTOMATION_STATS_SUCCESS,
	UPDATE_AUTOMATION_EVENTS,
	UPDATE_AUTOMATION_GENERAL_ISSUES,
	UPDATE_AUTOMATION_SELECTED_EVENT,
	SET_EDITOR_MODE,
	GET_ACTION_STATS_SUCCESS,
	UPDATE_ACTIVE_AUTOMATION,
	SET_SHOW_CONTROL_PANEL,
	UNDO_AUTOMATION,
	REDO_AUTOMATION,
	ADD_SNAPSHOT,
	LIST_VISITORS_SUCCESS,
	OPEN_SUB_SCENE,
	GET_SEGMENTS_OF_AUTOMATION_LIST_SUCCESS,
	SET_TOTAL_CONTACTS_COUNT,
	LIST_AB_TESTS,
	SET_AUTOMATION_MATCHES_ACCOUNT_PLAN,
} from "assets/js/data/automations/types";
import { listWorkflowBlueprintsService } from "assets/js/services/AutomationBluePrint";
import {
	listAutomationsService,
	createAutomationService,
	getAutomationService,
	deactivateAutomationService,
	activateAutomationService,
	publishAutomationService,
	createEmailContentService,
	copyEmailContentService,
	updateAutomationService,
	getStepStatsService,
	listAutomationExecutionsService,
	terminateExecutionService,
	pauseAutomationService,
	unpauseAutomationService,
	createCustomEventService,
	triggerAutomationManuallyService,
	triggerBatchAutomationService,
	listAutomationVisitorsService,
} from "assets/js/services/automationService";
import { mapFEEventsToBEEvents } from "assets/js/scenes/automations/containers/editor/Mapper";
import { EDITOR_MODE } from "assets/js/const/Automations";

const setAutomation = (automations) => {
	return {
		type: SET_AUTOMATION,
		automations,
		editorMode: EDITOR_MODE.WORKFLOW,
	};
};
const openSubScene = (scene, configs) => {
	return {
		type: OPEN_SUB_SCENE,
		scene: scene,
		configs: configs,
	};
};
const setShowControlPanel = (isTrue) => {
	return {
		type: SET_SHOW_CONTROL_PANEL,
		showControlPanel: isTrue,
	};
};
const addSnapshot = (events) => {
	return {
		type: ADD_SNAPSHOT,
		events: events,
	};
};
const setAutomationEventsRequireUpgrade = (value) => {
	return {
		type: SET_AUTOMATION_MATCHES_ACCOUNT_PLAN,
		value: value,
	};
};
const updateAutomationEvent = (
	updatedEvent,
	addSnapshot = false,
	snapShotTags
) => {
	return {
		type: UPDATE_AUTOMATION_EVENT,
		updatedEvent: updatedEvent,
		updatedEventId: updatedEvent.id,
		addSnapshot: addSnapshot,
		snapShotTags: snapShotTags,
	};
};
const updateAutomationEvents = (
	updatedEvents,
	addSnapshot,
	snapShotTags,
	adjustLayout,
	addPadding = false
) => {
	return {
		type: UPDATE_AUTOMATION_EVENTS,
		updatedEvents: layoutedEvents(updatedEvents, addPadding),
		addSnapshot: addSnapshot,
		snapShotTags: snapShotTags,
		adjustLayout: adjustLayout,
	};
};

const updateAutomationEventsSuccess = (updatedEvents) => {
	return {
		type: UPDATE_AUTOMATION_EVENTS,
		updatedEvents: updatedEvents,
	};
};

const turnOnAutomation = (
	id,
	committed_on,
	isPaused,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		publishAutomationService(
			{ automationId: id },
			() => {
				activateAutomationService(
					{ id: id },
					(activatedata) => {
						if (isPaused) {
							unpauseAutomationService(
								{ automationId: id },
								(data) => {
									dispatch(activateAutomationSuccess(data.data));
									if (successCallback) successCallback(data.data);
								},
								(response) => {
									if (failureCallback) failureCallback();
								}
							);
						} else {
							dispatch(activateAutomationSuccess(activatedata));
							if (successCallback) successCallback(activatedata);
						}
					},
					() => {
						if (failureCallback) failureCallback();
					}
				);
			},
			(p1, response, p3) => {
				if (response.status == 400 || response.status == 504) {
					setTimeout(
						() =>
							getAutomationService(
								{
									id: id,
								},
								(data) => {
									if (data.data.committed_on > committed_on) {
										activateAutomationService(
											{ id: id },
											(activatedata) => {
												if (isPaused) {
													unpauseAutomationService(
														{ automationId: id },
														(data) => {
															dispatch(activateAutomationSuccess(data.data));
															if (successCallback) successCallback(data.data);
														},
														(response) => {
															dispatch(activateAutomationFailure(data.data));
															if (failureCallback) failureCallback();
														}
													);
												} else {
													dispatch(activateAutomationSuccess(activatedata));
													if (successCallback) successCallback(activatedata);
												}
											},
											() => {
												if (failureCallback) failureCallback();
											}
										);
									} else {
										dispatch(activateAutomationFailure(data.data));
										if (failureCallback) failureCallback();
									}
								}
							),
						50000
					);
				}
				// dispatch(updateActionFailure());
				else if (failureCallback) failureCallback();
			}
		);
	};
};
const turnOffAutomation = (id, successCallback, failureCallback) => {
	return function (dispatch) {
		pauseAutomationService(
			{ automationId: id },
			() => {
				deactivateAutomationService({ id: id }, (data) => {
					if (successCallback) {
						dispatch(
							deactivateAutomationSuccess(data, "inactive", data.data.paused)
						);
						successCallback();
					}
				});
			},
			() => {
				if (failureCallback) failureCallback();
			}
		);
	};
};
const publishAutomation = (id, successCallback, failureCallback) => {
	return function (dispatch) {
		publishAutomationService(
			{ automationId: id },
			() => {
				// dispatch(updateActionSuccess());
				if (successCallback) successCallback();
			},
			() => {
				// dispatch(updateActionFailure());
				if (failureCallback) failureCallback();
			}
		);
	};
};
const updateAutomationGeneralIssues = (issues) => {
	return {
		type: UPDATE_AUTOMATION_GENERAL_ISSUES,
		issues: issues,
	};
};
const setEditorMode = (mode) => {
	return {
		type: SET_EDITOR_MODE,
		editorMode: mode,
	};
};

const addAutomationEvent = (addedEvent) => {
	addedEvent.created = true;
	return {
		type: ADD_AUTOMATION_EVENT,
		addedEvent: addedEvent,
	};
};
const resetAutomationEvents = () => {
	return {
		type: RESET_AUTOMATION_EVENTS,
	};
};
const deleteAutomationEvent = (id) => {
	return {
		type: DELETE_AUTOMATION_EVENT,
		deletedEventId: id,
	};
};
const updateSelectedEvent = (id) => {
	return {
		type: UPDATE_AUTOMATION_SELECTED_EVENT,
		id: id,
	};
};
const customEventPayload = (automationName) => {
	return {
		description: `${automationName}_customEvent`,
		schema: {
			type: "object",
			properties: {
				step: {
					type: "string",
				},
				contact: {
					type: "object",
				},
			},
			required: ["step", "contact"],
			$schema: "http://json-schema.org/draft-07/schema#",
		},
	};
};
const listSegmentsOfSelectedList = (listId, accountId) => {
	return function (dispatch) {
		// list all the segments
		let options = { perPage: 1000, accountId: accountId };
		listSegmentService({ id: listId, ...options, withCount: true }, (data) => {
			dispatch(getSegmentsOfAutomationListSuccess(data));
		});
	};
};
// to create an automation we need to get the contact lists first and select the first list by default as
// audience lists is mandatory param
const createAutomation = (
	accountId,
	automationName,
	description,
	trigger = "subscribed",
	goal,
	audienceListId,
	templateId,
	senderId,
	successCallback,
	failureCallback
) => {
	const defaultAutomationObject = {
		name: automationName,
		list_id: parseInt(audienceListId),
		editor_version: "2.01",
		trigger: [
			{
				args: {
					list_id: parseInt(audienceListId),
				},
				name: "Contact.Added",
			},
			{
				name: "Custom.Event",
				args: {
					customevent_id: null,
				},
			},
		],
		main: {
			steps: [],
		},
	};
	return function (dispatch) {
		if ((templateId && senderId) || !templateId) {
			const options = {
				accountId: accountId,
				name: automationName,
				// we will default to others option
				goal: goal || I18n._translate("app-automation-goal_6-title"),
				audience: { list_id: parseInt(audienceListId) },

				trigger: trigger,
			};
			if (description) {
				options.description = description;
			}
			if (templateId) {
				options.blueprint = {
					id: templateId,
					email_settings: {
						sender: {
							id: senderId,
						},
					},
				};
			}

			createCustomEventService(
				customEventPayload(automationName),
				(customEventData) => {
					defaultAutomationObject.trigger.filter(
						(trigger) => trigger.name == "Custom.Event"
					)[0].args.customevent_id = customEventData.id;
					createAutomationService(
						defaultAutomationObject,
						(data) => {
							dispatch(createAutomationSuccess(data));
							if (successCallback) successCallback(data);
						},
						(data) => {
							dispatch(createAutomationFailure());
							if (failureCallback) failureCallback(data);
						}
					);
				}
			);
		}
	};
};

const createMarketingAccountAutomation = (
	automationName,
	description,
	accountLineage,
	selectedListId,
	successCallback,
	failureCallback
) => {
	const resellerLineage = accountLineage.substring(0, accountLineage.lastIndexOf('-'));
	const defaultAutomationObject = {
		"name": automationName,
		"description": description,
		"editor_version": "2.01",
		"list_id": selectedListId,
		"trigger": [
			{
				"args": {
					"lineage": resellerLineage
				},
				"name": "User.Updated"
			},
			{
				"args": {
					"lineage": resellerLineage
				},
				"name": "User.Confirmed"
			}
		],
		"main": {
			"steps": [
				{
					"args": {
						"account_id": "${input.account_id}"
					},
					"name": "get_the_account",
					"action": "Account.Get"
				},
				{
					"args": {
						"is_account_owner": 0
					},
					"name": "init_is_account_owner",
					"action": "Variable.Set"
				},
				{
					"name": "check_if_delete",
					"action": "Condition.Switch",
					"args": {
						"switch": [
							{
								"steps": [
									{
										"args": {
											"in": [
												`${selectedListId}`
											],
											"value": "one_list_id"
										},
										"name": "update_all_lists",
										"action": "For.Loop",
										"steps": [
											{
												"args": {
													"list_id": "${one_list_id}",
													"email": "${input.data.user.email}",
													"custom_attributes": [
														{
															"name": "language",
															"value": "${input.data.user.language}"
														},
														{
															"name": "first_name",
															"value": "${input.data.user.first_name}"
														},
														{
															"name": "last_name",
															"value": "${input.data.user.last_name}"
														},
														{
															"name": "is_account_owner",
															"value": "${get_the_account_output.body.data.account_owner.user_id == input.data.user.id}"
														},
														{
															"name": "account_created_on",
															"value": "${get_the_account_output.body.data.created_on}"
														},
														{
															"name": "account_country",
															"value": "${get_the_account_output.body.data.address.country}"
														},
														{
															"name": "account_city",
															"value": "${get_the_account_output.body.data.address.city}"
														},
														{
															"name": "account_id",
															"value": "${input.account_id}"
														},
														{
															"name": "account_status",
															"value": "${get_the_account_output.body.data.status}"
														},
														{
															"name": "user_status",
															"value": "${input.data.user.status}"
														},
														{
															"name": "user_id",
															"value": "${input.data.user.id}"
														}
													]
												},
												"name": "Add_Contact",
												"action": "Contact.Add"
											}
										]
									}
								],
								"condition": {
									"eq": {
										"value": true,
										"var": "${input.data.user.status != \"deleted\"}"
									}
								}

							}
						]
					}
				}
			]
		},
		"sub_automations": []
	};
	return function (dispatch) {
		createAutomationService(
			defaultAutomationObject,
			(data) => {
				dispatch(createAutomationSuccess(data));
				if (successCallback) successCallback(data);
			},
			(data) => {
				dispatch(createAutomationFailure());
				if (failureCallback) failureCallback(data);
			}
		);
	};
};
const listAutomations = (
	accountId,
	page = 1,
	perPage = 100,
	search = null,
	sort = "-created_on",
	filters = [],
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		let options = {
			accountId: accountId,
			page: page,
			perPage: perPage,
			sort: sort,
			withCount: true,
		};
		// we will need to add the search values to the filters with name , then join them all to one string
		// BE accepts the filters as concatenated string with ;
		const updatedFilters = [...filters];
		if (search) updatedFilters.push({ name: `*${search}*` });
		const filterString = updatedFilters
			.map((filter) => `${Object.keys(filter)[0]}==${Object.values(filter)[0]}`)
			.filter(Boolean)
			.join(";");

		if (filterString) {
			options.filter = filterString;
		}
		listAutomationsService(
			options,
			(data) => {
				dispatch(listAutomationsSuccess(data));
				if (successCallback) successCallback(data);
			},
			(msg) => {
				dispatch(
					listAutomationsFailure({
						pagination: { count: 0 },
						msg: "Unable to fetch automation blueprints",
						data: [],
					})
				);
				if (failureCallback) failureCallback(msg);
			}
		);
	};
};
const listAutomationsBluePrints = (
	accountId,
	page = 1,
	perPage = 25,
	search = null,
	sort = "-created_on",
	filters = [],
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		let options = {
			accountId: accountId,
			page: page,
			perPage: perPage,
			sort: sort,
			withCount: true,
		};
		// we will need to add the search values to the filters with name , then join them all to one string
		// BE accepts the filters as concatenated string with ;
		const updatedFilters = [...filters];
		if (search) updatedFilters.push({ name: `*${search}*` });
		const filterString = updatedFilters
			.map((filter) => `${Object.keys(filter)[0]}==${Object.values(filter)[0]}`)
			.filter(Boolean)
			.join(";");

		if (filterString) {
			options.filter = filterString;
		}
		listWorkflowBlueprintsService(
			options,
			(data) => {
				dispatch(listAutomationBluePrintsSuccess(data));
				if (successCallback) successCallback(data);
			},
			(msg) => {
				dispatch(
					listAutomationBluePrintsFailure({
						pagination: { count: 0 },
						msg: "Unable to fetch automation blueprints",
						data: [],
					})
				);
				if (failureCallback) failureCallback(msg);
			}
		);
	};
};
const getStats = (
	accountId,
	automationId,
	steps,
	startTime,
	endTime,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		steps.forEach((step) => {
			let statsTypeResults = [];
			const promises = [];
			if (step.data.email.content.id !== "scratchBee1") {
				statsTypeResults.push({ id: step.id, data: {} });
				promises.push(
					new Promise((resolve, reject) => {
						const options = {
							accountId: accountId,
							stepId: `${step.id}`,
							automationId: automationId,
						};
						if (startTime) options.startTime = startTime;
						if (endTime) options.endTime = endTime;
						getStepStatsService(
							options,
							(data) => {
								// returned data from the api is sometimes data:{{}}, when no data to be retreived, this is breaking
								// the structure, so we will convert the data here when empty to the proper structure
								if (!data.data.groupedByContact) {
									data.data.groupedByContact = {
										open: 0,
										clickthru: 0,
										sent: 0,
										subscribe: 0,
										unsubscribe: 0,
										bounce: 0,
										soft_bounce: 0,
										hard_bounce: 0,
										spam: 0,
									};
									data.data.totals = {
										open: 0,
										clickthru: 0,
										sent: 0,
										subscribe: 0,
										unsubscribe: 0,
										bounce: 0,
										soft_bounce: 0,
										hard_bounce: 0,
										spam: 0,
									};
								}
								dispatch(getActionStatsSuccess(data.data, step.id));
								resolve(data);
							},
							(msg) => {
								reject(msg);
							}
						);
					})
				);
			}
			if (promises.length != 0) {
				Promise.all(promises)
					.then((promise) => {
						if (promise.length === promises.length) {
							if (successCallback) {
								successCallback("", "", "");
							}
						}
					})
					.catch(function (err) {
						if (failureCallback) failureCallback();
					});
			}
		});
	};
};
const getAutomation = (
	accountId,
	automationId,
	successCallback,
	failureCallback
) => {
	const startTime = moment().subtract(24, "hours").unix();
	const endTime = moment().unix();
	return function (dispatch) {
		getAutomationService(
			{ accountId: accountId, id: automationId },
			(data) => {
				if (data.data.editor_version == "manual") {
					// need to get the contacts
					// need to get statsC and statsD
					const options = {
						accountId: accountId,
						stepId: "pathC",
						automationId: data.data.id,
					};
					getStepStatsService(options, (statsC) => {
						getStepStatsService({ ...options, stepId: "pathD" }, (statsD) => {
							data.data.statsC = statsC.data;
							data.data.statsD = statsD.data;
							let events = [];
							if (window.localStorage.getItem(`automations-${automationId}`)) {
								events = JSON.parse(
									window.localStorage.getItem(`automations-${automationId}`)
								).automationPlan;
							} else {
								events = layoutedEvents(mapBEStepsToFEEvents(data.data));
							}

							dispatch(getAutomationSuccess(data, events));
							successCallback(data);
						});
					});
				} else {
					let events = [];
					// if (window.localStorage.getItem(`automations-${automationId}`)) {
					// 	events = JSON.parse(
					// 		window.localStorage.getItem(`automations-${automationId}`)
					// 	).automationPlan;
					// } else {

					try {
						events = layoutedEvents(mapBEStepsToFEEvents(data.data));
					} catch (error) {
						const errorEvent = [{
							id: "e1_1111",
							position: { "x": 0, "y": 0 },
							data:
							{
								name: I18n._translate("app-automation-editor_events_error_name"),
								desc: I18n._translate("app-automation-editor_events_error_desc"), type: "action",
								tileTitle: "app-automation--error_tileTitle",
								id: "e1_1111",
								baseId: "error",
								initialElement: true,
								shadows: []
							},
							type: "editorNode"
						}];
						events = layoutedEvents(errorEvent);
					}

					dispatch(getAutomationSuccess(data, events));
					successCallback(data);
				}
			},
			(data) => {
				dispatch(getAutomationFailure(data));
				if (failureCallback) failureCallback(data);
			}
		);
	};
};

const activateAutomation = (
	accountId,
	automationId,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		activateAutomationService(
			{ id: automationId, accountId: accountId },
			(data) => {
				dispatch(activateAutomationSuccess(data));
				if (successCallback) successCallback();
			},
			(customErrorKey) => {
				if (failureCallback) failureCallback(data, customErrorKey);
			}
		);
	};
};
const deactivateAutomation = (
	automationId,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		deactivateAutomationService(
			{ id: automationId },
			(data) => {
				dispatch(
					deactivateAutomationSuccess(data, "inactive", data.data.paused)
				);
				if (successCallback) successCallback();
			},
			() => {
				if (failureCallback) failureCallback();
			}
		);
	};
};
const createAnAutomationFromTemplate = (
	template,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		const promises = [];
		delete template.id;
		createCustomEventService(
			customEventPayload(template.name),
			(customEventData) => {
				template.trigger[0].args.customevent_id = customEventData.id;
				template.sub_automations.filter(
					(sub) => sub.name == "emit_next_step"
				)[0].steps[0].args.customevent_id = customEventData.id;

				template.main.steps.forEach((step) => {
					if (step.action == "CampaignEmail.Send") {
						const subStepSendEmail = step;
						if (subStepSendEmail) {
							promises.push(
								new Promise((resolve, reject) => {
									copyEmailContentService(
										{
											contentId: subStepSendEmail.args.content.id,
											subject: subStepSendEmail.args.subject,
											senderId: subStepSendEmail.args.sender.id,
										},
										(data) => {
											subStepSendEmail.args.content.id = data.id;
											resolve(data);
										},
										(error) => {
											reject(error);
										}
									);
								})
							);
						}
					}
				});
				if (promises.length != 0) {
					Promise.all(promises)
						.then((promise) => {
							if (promise.length === promises.length) {
								createAutomationService(
									template,
									successCallback,
									failureCallback
								);
							}
						})
						.catch(function (err) {
							failureCallback();
						});
				} else {
					createAutomationService(template, successCallback, failureCallback);
				}
			}
		);
	};
};
const updateCustomEvent = (obj, newValue) => {
	if (Array.isArray(obj)) {
		obj.forEach(item => updateCustomEvent(item, newValue));
	} else if (typeof obj === 'object' && obj !== null) {
		Object.keys(obj).forEach(key => {
			if (key === 'customevent_id') {
				obj[key] = newValue;
			} else {
				updateCustomEvent(obj[key], newValue);
			}
		});
	}
};
const duplicateAutomation = (
	automationId,
	newName,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		createCustomEventService(
			customEventPayload(newName),
			(customEventData) => {
				getAutomationService({ id: automationId }, (data) => {
					updateCustomEvent(data.data, customEventData.id);
					data.data.name = newName;
					delete data.data.updated_on;
					delete data.data.created_on;
					delete data.data.committed_on;
					delete data.data.committed_revision;
					delete data.data.paused;
					delete data.data.status;
					delete data.data.id;
					const promises = [];

					data.data.main.steps.forEach((step) => {
						if (step.action == "CampaignEmail.Send") {
							const subStepSendEmail = step;
							if (subStepSendEmail) {
								promises.push(
									new Promise((resolve, reject) => {
										copyEmailContentService(
											{
												contentId: subStepSendEmail.args.content.id,
												subject: subStepSendEmail.args.subject,
												senderId: subStepSendEmail.args.sender.id,
											},
											(data) => {
												subStepSendEmail.args.content.id = data.id;
												resolve(data);
											},
											(error) => {
												reject(error);
											}
										);
									})
								);
							}
						}
					});
					if (promises.length != 0) {
						Promise.all(promises)
							.then((promise) => {
								if (promise.length === promises.length) {
									createAutomationService(
										data.data,
										() => {
											if (successCallback) successCallback();
										},
										() => {
											if (failureCallback) failureCallback();
										}
									);
								}
							})
							.catch(function (err) {
								failureCallback();
							});
					} else {
						createAutomationService(
							data.data,
							() => {
								if (successCallback) successCallback();
							},
							() => {
								if (failureCallback) failureCallback();
							}
						);
					}
				});
			}
		);
	};
};

const updateAutomation = (
	automationEvents,
	automation,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		const requestTime = Date.now();
		// we need to make sure that all automation contents have a valid email content id
		let promises = [];
		automationEvents.forEach((event, index) => {
			if (event.data.baseId == "sendEmail") {
				if (
					event.data.email.content.id == "scratchBee1" ||
					event.data.email.content.id == "new"
				) {
					promises.push(
						new Promise((resolve, reject) => {
							createEmailContentService(
								{
									json:
										event.data.email.content.id == "scratchBee1"
											? beeTemplate()
											: event.data.email.content.json,
									html:
										event.data.email.content.id == "scratchBee1"
											? beeTemplate1Render()
											: event.data.email.content?.html
												? event.data.email.content.html
												: null,
								},
								(data) => {
									event.data.email.content.id = data.id
										? data.id
										: data.data.id;
									resolve(data);
								},
								(data) => {
									reject(data);
								}
							);
						})
					);
				}
			}
		});
		if (promises.length != 0) {
			Promise.all(promises)
				.then((promise) => {
					if (promise.length === promises.length) {
						if (!automation.customevent_id) {
							createCustomEventService(
								customEventPayload(automation.name),
								(customEventData) => {
									automation.customevent_id = customEventData.id;
									updateAutomationService(
										{
											automation: mapFEEventsToBEEvents(
												automationEvents,
												automation
											),
											id: automation.id,
										},
										(data) => {
											dispatch(updateAutomationSuccess(data));
											if (successCallback) successCallback(data, requestTime);
										},
										(msg, response) => {
											if (failureCallback) failureCallback(response);
										}
									);
								},
								() => { }
							);
						} else {
							updateAutomationService(
								{
									automation: mapFEEventsToBEEvents(
										automationEvents,
										automation
									),
									id: automation.id,
								},
								(data) => {
									dispatch(updateAutomationSuccess(data));
									if (successCallback) successCallback(data, requestTime);
								},
								(msg, response) => {
									if (failureCallback) failureCallback(response);
								}
							);
						}
					}
				})

				.catch(function (err) {
					failureCallback();
				});
		} else {
			if (automationEvents[0]?.data?.baseId === "error") {
				if (successCallback) successCallback(automation, requestTime);
				return;
			}
			if (!automation.customevent_id) {
				createCustomEventService(
					customEventPayload(automation.name),
					(customEventData) => {
						automation.customevent_id = customEventData.id;
						updateAutomationService(
							{
								automation: mapFEEventsToBEEvents(automationEvents, automation),
								id: automation.id,
							},
							(data) => {
								dispatch(updateAutomationSuccess(data));
								if (successCallback) successCallback(data, requestTime);
							},
							(data) => {
								if (failureCallback) failureCallback(data);
							}
						);
					},
					() => { }
				);
			} else {
				updateAutomationService(
					{
						automation: mapFEEventsToBEEvents(automationEvents, automation),
						id: automation.id,
					},
					(data) => {
						dispatch(updateAutomationSuccess(data));
						if (successCallback) successCallback(data, requestTime);
					},
					(data) => {
						if (failureCallback) failureCallback(data);
					}
				);
			}
		}
	};
};
const createEmailContent = (
	options,
	successCallback,
	failureCallback = () => { }
) => {
	const { subject, json, html, senderId } = options;
	return function (dispatch) {
		// we need to send the default email object
		createEmailContentService(
			{
				subject: subject,
				senderId: senderId,
				json: json,
				html: html,
			},
			(data) => {
				//dispatch(createEmailContentSuccess(updatedEvent));
				if (successCallback) successCallback(data);
			},
			failureCallback
		);
	};
};

const listActiveAutomationExecutions = (
	automationId,
	versionId,
	successCallback
) => {
	return function (dispatch) {
		const executions = {};
		const listingRecursive = (nextPageToken, callback) => {
			listAutomationExecutionsService(
				{
					automationId: automationId,
					perPage: 1000,
					nextPageToken: nextPageToken,
				},
				(data) => {
					data.data.forEach((exec) => {
						if (!executions[exec.automationVersion]) {
							executions[exec.automationVersion] = { active: [] };
						}
						if (exec.state == "ACTIVE") {
							executions[exec.automationVersion].active.push(exec.id);
						}
					});
					if (data.pagination.nextPageToken) {
						listingRecursive(data.pagination.nextPageToken, callback);
					} else callback();
				}
			);
		};
		listingRecursive(null, () => {
			successCallback(versionId ? executions[versionId] : executions);
		});
	};
};
const terminateListOfExecutions = (
	automationId,
	listOfExecutions,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		const promises = [];
		listOfExecutions.forEach((exec) => {
			promises.push(
				new Promise((resolve, reject) => {
					terminateExecutionService(
						{ executionId: exec, automationId: automationId },
						(data) => {
							//dispatch(getActionStatsSuccess(data.data, step.id));
							resolve(data);
						},
						(data) => {
							reject(data);
						}
					);
				})
			);
		});
		if (promises.length != 0) {
			Promise.all(promises)
				.then((promise) => {
					if (promise.length === promises.length) {
						if (successCallback) {
							successCallback("", "", "");
						}
					}
				})
				.catch(function (err) {
					failureCallback();
				});
		} else {
			successCallback("", "", "");
		}
	};
};
const triggerBatchAutomation = (
	automationId,
	accountId,
	jsonFilter,
	stepId,
	excludeContacts,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		const triggerObject = {
			account_id: accountId,
			jsonFilter: JSON.stringify(jsonFilter),
			skipAlreadyVisited: false,
		};
		if (stepId)
			triggerObject.appendPayload = {
				data: {
					step: stepId,
				},
			};
		triggerBatchAutomationService(
			{ automationId: automationId, ...triggerObject },
			successCallback,
			failureCallback
		);
	};
};
const triggerAutomationManually = (
	automationId,
	accountId,
	contact,
	stepId,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		const triggerObject = {
			account_id: accountId,
			data: {
				contact: contact,
			},
		};
		if (stepId) triggerObject.data.step = stepId;
		triggerAutomationManuallyService(
			{ automationId: automationId, ...triggerObject },
			successCallback,
			failureCallback
		);
	};
};
const listAutomationVisitors = (
	automationId,
	accountId,
	successCallback,
	failureCallback
) => {
	return function (dispatch) {
		listAutomationVisitorsService(
			{ automationId: automationId, accountId: accountId },
			(data) => {
				dispatch(listAutomationVisitorsSuccess(data.data));
				if (successCallback) successCallback(data);
			},
			failureCallback
		);
	};
};

const makeRandomSelectionOfSamples = (contactsSample, sampleSize) => {
	const doubleSampleSize = 2 * sampleSize;
	const copyOfContactsSample = [...contactsSample];
	for (var index = copyOfContactsSample.length - 1; index > 0; index--) {
		var rndIndex = Math.floor(Math.random() * (index + 1));
		var subjNameTemp = copyOfContactsSample[rndIndex];
		copyOfContactsSample[rndIndex] = copyOfContactsSample[index];
		copyOfContactsSample[index] = subjNameTemp;
	}
	var getRandomSubjectName = copyOfContactsSample.slice(0, doubleSampleSize);
	return {
		pathA: getRandomSubjectName.slice(0, sampleSize),
		pathB: getRandomSubjectName.slice(sampleSize, doubleSampleSize),
	};
};
const getAllContacts = (
	listId,
	accountId,
	totalContactsCount,
	query,
	sampleFromEachPage,
	numberOfAvaiablePages,
	sampleSize,
	jsonFilter,
	successCallback
) => {
	const allRandomContacts = { pathA: [], pathB: [] };
	const getService = (page, perPage) => {
		return new Promise(function (resolve, reject) {
			getContactsOfListService(
				{
					accountId: accountId,
					listId: listId,
					page: page,
					perPage: perPage,
					json: JSON.stringify(jsonFilter),
					withCount: true,
				},
				(data) => {
					const randomSelectionOfSamples = makeRandomSelectionOfSamples(
						data.data,
						sampleFromEachPage
					);
					allRandomContacts.pathA = [
						...allRandomContacts.pathA,
						...randomSelectionOfSamples.pathA,
					];
					allRandomContacts.pathB = [
						...allRandomContacts.pathB,
						...randomSelectionOfSamples.pathB,
					];
					resolve();
				},
				() => {
					reject();
				}
			);
		});
	};
	let page = 0;
	const perPage = 50;
	var promiseProducer = function () {
		if (page < numberOfAvaiablePages) {
			page++;
			return getService(page, perPage);
		} else {
			return null;
		}
	};
	const pool = new promisePool(promiseProducer, 10);

	pool.start().then(() => {
		successCallback(allRandomContacts);
	});
};
const getRandomContacts = (
	listId,
	accountId,
	sampleSize,
	totalContactsSize,
	jsonFilter,
	successCallback
) => {
	return function (dispatch) {
		const CONTACTS_GET_BATCH_SIZE = 50;
		const numberOfAvaiablePages = totalContactsSize / CONTACTS_GET_BATCH_SIZE;

		//if(sampleSize >= numberOfAvaiablePages){
		const sampleFromEachPage = Math.ceil(sampleSize / numberOfAvaiablePages);
		// start getting all the pages
		dispatch(
			getAllContacts(
				listId,
				accountId,
				totalContactsSize,
				"",
				sampleFromEachPage,
				numberOfAvaiablePages,
				sampleSize,
				jsonFilter,
				(data) => {
					const sample = {
						pathA: data.pathA.splice(0, sampleSize),
						pathB: data.pathB.splice(0, sampleSize),
					};
					successCallback(sample);
				}
			)
		);
		//}
	};
};
const triggerForABTests = (
	listId,
	sampleSize,
	activeAutomation,
	account,
	jsonFilter,
	totalContactsCount,
	successCallback,
	successCallback2
) => {
	return function (dispatch) {
		dispatch(
			getRandomContacts(
				listId,
				account.id,
				sampleSize,
				totalContactsCount,
				jsonFilter,
				(data) => {
					//successCallback(data.data);
					//const paths = makeRandomSelectionOfSamples(data.data.map(c=>c.id), sampleSize);
					let paths = {
						pathA: data.pathA.map((c) => c.id),
						pathB: data.pathB.map((c) => c.id),
					};
					const selectedContactsJsonA = {
						or: [],
					};
					paths.pathA.forEach((c) => {
						selectedContactsJsonA.or.push({
							eq: {
								id: c,
							},
						});
					});
					const selectedContactsJsonB = {
						or: [],
					};
					paths.pathB.forEach((c) => {
						selectedContactsJsonB.or.push({
							eq: {
								id: c,
							},
						});
					});
					// trigger for pathA
					dispatch(
						triggerBatchAutomation(
							activeAutomation.id,
							account.id,
							selectedContactsJsonA,
							"pathA",
							false,
							() => {
								// trigger for pathB
								dispatch(
									triggerBatchAutomation(
										activeAutomation.id,
										account.id,
										selectedContactsJsonB,
										"pathB",
										false,
										() => {
											const updatedFilter = {
												and: jsonFilter ? [jsonFilter] : [],
											};
											const execludedJson = {
												and: [],
											};
											[...paths.pathA, ...paths.pathB].forEach((c) => {
												execludedJson.and.push({
													ne: {
														id: c,
													},
												});
											});

											updatedFilter.and.push(execludedJson);
											// trigger for pathC
											dispatch(
												triggerBatchAutomation(
													activeAutomation.id,
													account.id,
													updatedFilter,
													"winner",
													false,
													successCallback2
												)
											);
										}
									)
								);
							}
						)
					);
				}
			)
		);
	};
};
const getABTestStatsSuccess = (statses) => {
	return {
		type: GET_ABTEST_STATS_SUCCESS,
		data: statses,
	};
};
const getABTestSats = (id, accountId, successCallback) => {
	return function (dispatch) {
		const statses = [];
		const callback = () => {
			if (Object.keys(statses).length == 4) {
				successCallback(statses);
			}
		};
		getStepStatsService(
			{ stepId: "pathC", automationId: id, accountId: accountId },
			(pathCStats) => {
				statses.statsC = pathCStats;
				getStepStatsService(
					{ stepId: "pathD", automationId: id, accountId: accountId },
					(pathDStats) => {
						statses.statsD = pathDStats;
						callback();
					},
					() => {
						statses.statsD = null;
						callback();
					}
				);
			},
			() => {
				statses.statsC = null;
				getStepStatsService(
					{ stepId: "pathD", automationId: id, accountId: accountId },
					(pathDStats) => {
						statses.statsD = pathDStats;
						callback();
					},
					() => {
						statses.statsD = null;
						callback();
					}
				);
			}
		);
		getStepStatsService(
			{ stepId: "pathA", automationId: id, accountId: accountId },
			(pathAStats) => {
				statses.statsA = pathAStats;
				callback();
			},
			() => {
				statses.statsA = null;
				callback();
			}
		);
		getStepStatsService(
			{ stepId: "pathB", automationId: id, accountId: accountId },
			(pathBStats) => {
				statses.statsB = pathBStats;
				callback();
			},
			() => {
				statses.statsB = null;
				callback();
			}
		);
	};
};
const listABTests = (status, params, successCallback, failureCallback) => {
	return function (dispatch) {
		const options = { ...params };
		options.per_page = 100;
		options.page = 1;
		options.with_count = true;
		const outboxTests = [];
		const sentTests = [];
		let draftTests = [];
		let calculatedOutBox = null;
		listAutomationsService(
			options,
			(data) => {
				// filter by editor_version
				let aBTestsPlans = data.data.filter(
					(plan) => plan.editor_version == "manual"
				);

				if (status == "draft") {
					const draftTests = aBTestsPlans.filter(
						(plan) => !plan.committed_revision
					);
					dispatch(
						listABTestsSuccess({
							active: null,
							completed: null,
							drafts: draftTests,
						})
					);
					successCallback(draftTests);
				} else {
					const getAandBStats = () => {
						if (status == "active") {
							if (outboxTests.length + sentTests.length == 0) callback();
							[...outboxTests, ...sentTests].forEach((plan) => {
								getStepStatsService(
									{ stepId: "pathA", automationId: plan.id },
									(pathAStats) => {
										plan.statsA = pathAStats;
										getStepStatsService(
											{ stepId: "pathB", automationId: plan.id },
											(pathBStats) => {
												plan.statsB = pathBStats;
												callback();
											},
											() => {
												callback();
											}
										);
									},
									() => {
										getStepStatsService(
											{ stepId: "pathB", automationId: plan.id },
											(pathBStats) => {
												plan.statsB = pathBStats;
												callback();
											},
											() => {
												callback();
											}
										);
									}
								);
							});
						}
					};
					const callback = () => {
						if (sentTests.length + outboxTests.length == aBTestsPlans.length) {
							if (
								status == "active" &&
								(outboxTests.length > 0 || sentTests.length > 0)
							) {
								if (calculatedOutBox == null) {
									calculatedOutBox = 0;
									getAandBStats();
								} else {
									calculatedOutBox = calculatedOutBox + 1;
									if (
										calculatedOutBox ==
										outboxTests.length + sentTests.length
									) {
										dispatch(
											listABTestsSuccess({
												active: outboxTests,
												completed: sentTests,
												drafts: draftTests,
											})
										);
										successCallback({
											active: outboxTests,
											completed: sentTests,
											drafts: draftTests,
										});
									}
								}
							} else {
								dispatch(
									listABTestsSuccess({
										active: outboxTests,
										completed: sentTests,
										drafts: draftTests,
									})
								);
								successCallback({
									active: outboxTests,
									completed: sentTests,
									drafts: draftTests,
								});
							}
						}
					};
					draftTests = aBTestsPlans.filter((plan) => !plan.committed_revision);
					aBTestsPlans = aBTestsPlans.filter((plan) => plan.committed_revision);

					if (status == "active" || status == "sent") {
						if (aBTestsPlans.length > 0)
							aBTestsPlans.forEach((plan) => {
								getStepStatsService(
									{ stepId: "pathC", automationId: plan.id },
									(pathCStats) => {
										if (
											!pathCStats.data?.groupedByContact?.sent ||
											pathCStats.data.groupedByContact?.sent == 0
										) {
											getStepStatsService(
												{ stepId: "pathD", automationId: plan.id },
												(pathDStats) => {
													if (
														!pathDStats.data?.groupedByContact?.sent ||
														pathDStats.data?.groupedByContact?.sent == 0
													) {
														if (plan.status == "active") {
															outboxTests.push({
																...plan,
																statsC: null,
																statsD: null,
															});
														} else {
															sentTests.push({
																...plan,
																statsD: null,
																statsC: null,
															});
														}
													} else {
														sentTests.push({
															...plan,
															statsD: pathDStats,
															statsC: null,
														});
													}
													callback();
												},
												() => {
													if (plan.status == "active") {
														outboxTests.push({
															...plan,
															statsD: null,
															statsC: null,
														});
													} else {
														sentTests.push({
															...plan,
															statsD: null,
															statsC: null,
														});
													}
													callback();
												}
											);
										} else {
											sentTests.push({
												...plan,
												statsC: pathCStats,
												pathD: null,
											});
										}
										callback();
									},
									() => {
										getStepStatsService(
											{ stepId: "pathD", automationId: plan.id },
											(pathDStats) => {
												if (
													!pathDStats.data?.groupedByContact?.sent ||
													pathDStats.data.groupedByContact.sent == 0
												) {
													if (plan.status == "active") {
														outboxTests.push({
															...plan,
															statsD: null,
															statsC: null,
														});
													} else {
														sentTests.push({
															...plan,
															statsD: null,
															statsC: null,
														});
													}
												} else {
													sentTests.push({
														...plan,
														statsD: pathDStats,
														statsC: null,
													});
												}
												callback();
											},
											() => {
												if (plan.status == "active") {
													outboxTests.push({
														...plan,
														statsD: null,
														statsC: null,
													});
												} else {
													sentTests.push({
														...plan,
														statsD: null,
														statsC: null,
													});
												}

												callback();
											}
										);
									}
								);
							});
						else {
							callback();
						}
					}
				}
			},
			(msg) => { }
		);
	};
};
const listABTestsSuccess = (data) => {
	return {
		type: LIST_AB_TESTS,
		data,
	};
};
const listAutomationVisitorsSuccess = (data) => {
	return {
		type: LIST_VISITORS_SUCCESS,
		data,
	};
};
const updateAutomationSuccess = (data) => {
	return {
		type: UPDATE_ACTIVE_AUTOMATION,
		data,
	};
};
const deactivateAutomationSuccess = (data, status, paused) => {
	return {
		type: DEACTIVATE_AUTOMATION_SUCCESS,
		data,
		status: status,
		paused: paused,
	};
};
const updateAutomationStatsSuccess = (data) => {
	return {
		type: UPDATE_AUTOMATION_STATS_SUCCESS,
		data,
	};
};

const activateAutomationSuccess = (data) => {
	return {
		type: ACTIVATE_AUTOMATION_SUCCESS,
		data,
	};
};

const activateAutomationFailure = (data) => {
	return {
		type: ACTIVATE_AUTOMATION_FAILURE,
		data,
	};
};

function getActionSuccess(data) {
	return { type: GET_ACTION_SUCCESS, action: data };
}
function getActionStatsSuccess(data, id) {
	return {
		type: GET_ACTION_STATS_SUCCESS,
		actionStats: { data: data, id: id },
	};
}
function renameAutomationSuccess(newName) {
	return {
		type: RENAME_AUTOMATION_SUCCESS,
		newName: newName,
	};
}
function listAutomationBluePrintsSuccess(data) {
	return { type: LIST_AUTOMATION_BLUEPRINTS_SUCCESS, data };
}
function getAutomationSuccess(data, updatedEvents) {
	return { type: GET_AUTOMATION_SUCCESS, data, updatedEvents: updatedEvents };
}
function getAutomationFailure() {
	return { type: GET_AUTOMATION_FAILURE };
}
function listAutomationBluePrintsFailure(data) {
	return {
		type: LIST_AUTOMATION_BLUEPRINTS_FAILURE,
	};
}

function listAutomationsSuccess(data) {
	return { type: LIST_AUTOMATIONS_SUCCESS, data };
}

function listAutomationsFailure(data) {
	return {
		type: LIST_AUTOMATIONS_FAILURE,
	};
}

function createAutomationSuccess(data) {
	return {
		type: CREATE_AUTOMATION_SUCCESS,
		data: data,
	};
}
function createAutomationFailure() {
	return {
		type: CREATE_AUTOMATION_FAILURE,
	};
}
function redoAutomation() {
	return {
		type: REDO_AUTOMATION,
	};
}
function undoAutomation() {
	return {
		type: UNDO_AUTOMATION,
	};
}
function getSegmentsOfAutomationListSuccess(data) {
	return {
		type: GET_SEGMENTS_OF_AUTOMATION_LIST_SUCCESS,
		data: data,
	};
}
function setTotalContactsCountForABTest(count) {
	return {
		type: SET_TOTAL_CONTACTS_COUNT,
		count: count,
	};
}

export {
	setAutomation,
	listAutomations,
	listAutomationsBluePrints,
	updateAutomationEvent,
	addAutomationEvent,
	resetAutomationEvents,
	createAutomation,
	createMarketingAccountAutomation,
	getAutomation,
	deleteAutomationEvent,
	deactivateAutomation,
	activateAutomation,
	updateAutomationEvents,
	getAutomationSuccess,
	updateSelectedEvent,
	updateAutomationGeneralIssues,
	setEditorMode,
	getStats,
	publishAutomation,
	updateAutomation,
	createEmailContent,
	renameAutomationSuccess,
	duplicateAutomation,
	turnOffAutomation,
	turnOnAutomation,
	listActiveAutomationExecutions,
	terminateListOfExecutions,
	setShowControlPanel,
	redoAutomation,
	undoAutomation,
	addSnapshot,
	triggerAutomationManually,
	listAutomationVisitors,
	listAutomationVisitorsSuccess,
	openSubScene,
	customEventPayload,
	triggerBatchAutomation,
	triggerForABTests,
	createAnAutomationFromTemplate,
	listSegmentsOfSelectedList,
	setTotalContactsCountForABTest,
	listABTests,
	getABTestSats,
	setAutomationEventsRequireUpgrade,
};
